import { z } from 'zod'

export const CurrencyAmountSchema = z.object({
  currency: z.string(),
  amount: z.number(),
})

export const OptionSchema = z.object({
  name: z.string(),
  value: z.string(),
})

export const ServiceStatusSchema = z.object({
  code: z.number(),
  message: z.optional(z.string()),
})

export const ServiceRequestSchema = z.object({
  requestId: z.optional(z.number()),
  sessionId: z.optional(z.nullable(z.string())),
  clientAgentString: z.optional(z.string()),
  options: z.optional(z.array(OptionSchema)),
})

export const ServiceResponseSchema = z.object({
  requestId: z.number(),
  serviceStatus: ServiceStatusSchema,
  traceId: z.string(),
  debugInfo: z.optional(z.string()),
  serverVersion: z.string(),
})
